"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamData = exports.colorRegexp = exports.datetimeRegexp = exports.defaultTimeOffset = exports.defaultMaxDimensions = void 0;
const istreamdata_1 = require("../interfaces/istreamdata");
const feed_1 = require("../classes/feed");
const payment_1 = require("../classes/payment");
const poll_1 = require("../classes/poll");
const media_1 = require("../classes/media");
const connectedplatform_1 = require("../classes/connectedplatform");
const errors_1 = require("../errors");
const consts_1 = require("../consts");
exports.defaultMaxDimensions = {
    max_width: 960,
    max_height: 540,
};
exports.defaultTimeOffset = 5 * 60 * 1000;
exports.datetimeRegexp = /[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}(?:(\.[0-9]{3}Z)|(\+[0-9]{2}:[0-9]{2}))/;
exports.colorRegexp = /(?:^\#([a-f0-9]{3}|[a-f0-9]{6})$)|(?:rgb\(([0-1]?[0-9]?[0-9]?|2[0-4][0-9]|25[0-5])([ ]+)?,([ ]+)?([0-1]?[0-9]?[0-9]?|2[0-4][0-9]|25[0-5])([ ]+)?,([ ]+)?([0-1]?[0-9]?[0-9]?|2[0-4][0-9]|25[0-5])\))/i;
class StreamData {
    constructor(rawData = {
        id: 0,
        type: 0,
        apikey: null,
        streamkey: null,
        webcam_streamkey: null,
        customer: '',
        campaign: '',
        title: 'New stream',
        title_color: '#000000',
        title_hidden: false,
        orientation: 1,
        width: null,
        height: null,
        max_width: exports.defaultMaxDimensions.max_width,
        max_height: exports.defaultMaxDimensions.max_height,
        video_layout: istreamdata_1.StreamVideoLayout.Fill,
        button_color: '#000000',
        text_color: '#ffffff',
        logo: null,
        cover: null,
        cover_portrait: null,
        vods: null,
        vod_data_id: '0',
        restreams: [],
        restream_title: null,
        restream_desc: null,
        restream_scheduling: null,
        restream_privacy_status: 'public',
        privacy_policy_url: null,
        start_date: null,
        end_date: null,
        timezone: null,
        timezone_offset: 0,
        feed: [],
        streamview_language: 'en',
        currency: 'huf',
        show_share_button: true,
        show_viewers: true,
        show_close_button: true,
        show_countdown_box: false,
        show_chat: true,
        show_product_list: true,
        show_polls: true,
        show_smuc_logo: true,
        show_title: true,
        show_like: true,
        show_like_demo: false,
        show_match_info: false,
        show_cheering: false,
        team_home_logo: null,
        team_away_logo: null,
        team_home_color: null,
        team_away_color: null,
        team_home_name: null,
        team_away_name: null,
        team_home_points: null,
        team_away_points: null,
        reversed_chat_moderation: false,
        auto_chat_moderation: false,
        is_sponsored_content: true,
        viewer_count: 0,
        ga_code: null,
        allow_extra_viewers: null,
        stream_status: istreamdata_1.StreamStatus.Waiting,
        payment: null,
        start_minimized: false,
        rounded_corners: true,
        optimize_for_ad: false,
        ad_bg: null,
        ad_size: null,
        ad_url: null,
        ad_button_label: null,
        ad_use_featured_image: null,
        ad_featured_image: null,
        ad_featured_image_link: null,
        rtmp_data: null,
        stream_urls: null,
        playlist: {},
        frequency: 'always',
        owner_id: null,
        impressions: 0,
        visible_impressions: 0,
        three_sec_views: 0,
        vcr: 0,
        video_clicks: 0,
        stored_minutes: 0,
        total_viewers: 0,
        total_minutes: 0,
        avg_viewed_minutes: 0,
        product_clicks: 0,
        product_link_clicks: 0,
        product_impressions: 0,
        product_ctr: 0,
        product_link_ctr: 0,
        product_purchases: 0,
        hearts: 0,
        comments: 0,
        shares: 0,
        total_interactions: 0,
        engagement_rate: 0,
        engagement_rate_based_on_visible_impression: 0,
        notification_email_subject: null,
        notification_email_text: null,
        subscribers: 0,
        embed_social_video: null,
        embed_social_video_processing: false,
        tab_products_label_singular: null,
        tab_products_label_plural: null,
        tab_subscription_form_label: null,
        purchase_gtc_url: null,
        embed_codes: null,
        player_url: null,
        player_autoplay: false,
        player_muted: false,
        player_loop: false,
        player_subdomain: null,
        font_id: null,
        font_meta: null,
        subscriber_form_id: null,
        subscriber_form: null,
        polls: [],
        agency_logo: null,
        photoad_photo: null,
        photoad_photos: [],
        photoad_autoswipe_duration: null,
        auto_card_timing: true,
        sidebar_transparency: true,
        delay_sidebar_appearance: null,
    }) {
        this.id = rawData.id || 0;
        this.type = rawData.type;
        this.apikey = rawData.apikey || null;
        this.streamkey = rawData.streamkey || null;
        this.webcam_streamkey = rawData.webcam_streamkey || null;
        this.customer = rawData.customer || '';
        this.campaign = rawData.campaign || '';
        this.title = rawData.title;
        this.title_color = rawData.title_color;
        this.title_hidden = rawData.title_hidden;
        this.orientation = rawData.orientation;
        this.width = rawData.width;
        this.height = rawData.height;
        this.max_width = rawData.max_width;
        this.max_height = rawData.max_height;
        this.video_layout = rawData.video_layout;
        this.button_color = rawData.button_color;
        this.text_color = rawData.text_color;
        this.logo =
            Object.prototype.toString.call(rawData.logo) === '[object Object]' && rawData.logo !== null
                ? new media_1.Media(rawData.logo.id, rawData.logo.url, rawData.logo.thumbnail_url)
                : null;
        this.cover =
            Object.prototype.toString.call(rawData.cover) === '[object Object]' && rawData.cover !== null
                ? new media_1.Media(rawData.cover.id, rawData.cover.url, rawData.cover.thumbnail_url)
                : null;
        this.cover_portrait =
            Object.prototype.toString.call(rawData.cover_portrait) === '[object Object]' && rawData.cover_portrait !== null
                ? new media_1.Media(rawData.cover_portrait.id, rawData.cover_portrait.url, rawData.cover_portrait.thumbnail_url)
                : null;
        this.vods = rawData.vods || null;
        this.vod_data_id = rawData.vod_data_id || '0';
        this.restreams = rawData.restreams;
        this.restream_title = rawData.restream_title;
        this.restream_desc = rawData.restream_desc;
        this.restream_scheduling = rawData.restream_scheduling;
        this.restream_privacy_status = rawData.restream_privacy_status;
        this.privacy_policy_url = rawData.privacy_policy_url;
        this.timezone = rawData.timezone;
        this.timezone_offset = rawData.timezone_offset;
        this.streamview_language = rawData.streamview_language;
        this.currency = rawData.currency || 'huf';
        this.show_share_button = this.parseBool(rawData.show_share_button);
        this.show_viewers = this.parseBool(rawData.show_viewers);
        this.show_close_button = this.parseBool(rawData.show_close_button);
        this.show_countdown_box = this.parseBool(rawData.show_countdown_box);
        this.show_chat = this.parseBool(rawData.show_chat);
        this.show_product_list = this.parseBool(rawData.show_product_list);
        this.show_polls = this.parseBool(rawData.show_polls);
        this.show_smuc_logo = this.parseBool(rawData.show_smuc_logo);
        this.show_title = this.parseBool(rawData.show_title);
        this.show_like = this.parseBool(rawData.show_like);
        this.show_like_demo = this.parseBool(rawData.show_like_demo);
        this.show_match_info = this.parseBool(rawData.show_match_info);
        this.show_cheering = this.parseBool(rawData.show_cheering);
        this.team_home_color = rawData.team_home_color;
        this.team_away_color = rawData.team_away_color;
        this.team_home_name = rawData.team_home_name;
        this.team_away_name = rawData.team_away_name;
        this.team_home_points = rawData.team_home_points || rawData.team_home_points == 0 ? rawData.team_home_points : null;
        this.team_away_points = rawData.team_away_points || rawData.team_away_points == 0 ? rawData.team_away_points : null;
        this.reversed_chat_moderation = this.parseBool(rawData.reversed_chat_moderation);
        this.auto_chat_moderation = this.parseBool(rawData.auto_chat_moderation);
        this.is_sponsored_content = this.parseBool(rawData.is_sponsored_content);
        this.viewer_count = rawData.viewer_count || 0;
        this.ga_code = rawData.ga_code;
        this.allow_extra_viewers = this.parseBool(rawData.allow_extra_viewers);
        this.stream_status = rawData.stream_status;
        this.payment =
            Object.prototype.toString.call(rawData.payment) == '[object Object]' && rawData.payment != null
                ? new payment_1.Payment(rawData.payment)
                : null;
        this.start_minimized = this.parseBool(rawData.start_minimized);
        this.rounded_corners = this.parseBool(rawData.rounded_corners);
        this.optimize_for_ad = this.parseBool(rawData.optimize_for_ad);
        this.ad_bg = rawData.ad_bg || null;
        this.ad_size = rawData.ad_size || null;
        this.ad_url = rawData.ad_url || null;
        this.ad_button_label = rawData.ad_button_label || null;
        this.ad_use_featured_image = rawData.ad_use_featured_image || null;
        this.ad_featured_image = rawData.ad_featured_image || null;
        this.ad_featured_image_link = rawData.ad_featured_image_link || null;
        this.rtmp_data = rawData.rtmp_data || null;
        this.stream_urls = rawData.stream_urls;
        this.playlist = rawData.playlist || {};
        this.frequency = rawData.frequency;
        this.owner_id = rawData.owner_id != null ? parseInt(rawData.owner_id.toString(), 10) : null;
        this.impressions = rawData.impressions || 0;
        this.visible_impressions = rawData.visible_impressions || 0;
        this.three_sec_views = rawData.three_sec_views || 0;
        this.vcr = rawData.vcr || 0;
        this.video_clicks = rawData.video_clicks || 0;
        this.stored_minutes = rawData.stored_minutes || 0;
        this.total_viewers = rawData.total_viewers || 0;
        this.total_minutes = rawData.total_minutes || 0;
        this.avg_viewed_minutes = rawData.avg_viewed_minutes || 0;
        this.product_clicks = rawData.product_clicks || 0;
        this.product_link_clicks = rawData.product_link_clicks || 0;
        this.product_impressions = rawData.product_impressions || 0;
        this.product_ctr = rawData.product_ctr || 0;
        this.product_link_ctr = rawData.product_link_ctr || 0;
        this.product_purchases = rawData.product_purchases || 0;
        this.hearts = rawData.hearts || 0;
        this.comments = rawData.comments || 0;
        this.shares = rawData.shares || 0;
        this.total_interactions = rawData.total_interactions || 0;
        this.engagement_rate = rawData.engagement_rate || 0;
        this.engagement_rate_based_on_visible_impression = rawData.engagement_rate_based_on_visible_impression || 0;
        this.notification_email_subject = rawData.notification_email_subject || '';
        this.notification_email_text = rawData.notification_email_text || '';
        this.subscribers = rawData.subscribers || 0;
        this.embed_social_video = rawData.embed_social_video;
        this.embed_social_video_processing = rawData.embed_social_video_processing || false;
        this.tab_products_label_singular = rawData.tab_products_label_singular || null;
        this.tab_products_label_plural = rawData.tab_products_label_plural || null;
        this.tab_subscription_form_label = rawData.tab_subscription_form_label || null;
        this.purchase_gtc_url = rawData.purchase_gtc_url || null;
        this.player_url = rawData.player_url || null;
        this.embed_codes = rawData.embed_codes || null;
        this.player_autoplay = rawData.player_autoplay || false;
        this.player_muted = rawData.player_muted || false;
        this.player_loop = rawData.player_loop || false;
        this.player_subdomain = rawData.player_subdomain || null;
        this.font_id = rawData.font_id || null;
        this.font_meta = rawData.font_meta || null;
        this.subscriber_form_id = rawData.subscriber_form_id || null;
        this.subscriber_form = rawData.subscriber_form || null;
        this.polls = (rawData.polls || [])
            .map((item) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return new poll_1.Poll(item);
        })
            .reverse();
        this.logo = null;
        if ('logo_url' in rawData) {
            this.logo = rawData.logo_url !== null ? new media_1.Media('0', '' + rawData.logo_url, '') : null;
        }
        this.agency_logo = null;
        this.cover = null;
        this.cover_portrait = null;
        this.photoad_photo = null;
        this.ad_featured_image = null;
        this.team_home_logo = null;
        this.team_away_logo = null;
        const imageFields = [
            'logo',
            'cover',
            'cover_portrait',
            'agency_logo',
            'photoad_photo',
            'ad_featured_image',
            'team_home_logo',
            'team_away_logo',
        ];
        imageFields.forEach((imageField) => {
            const key = imageField;
            if (!(imageField in rawData) || rawData[key] === null) {
                return;
            }
            const that = this;
            if (typeof rawData[key] === 'string') {
                that[key] = new media_1.Media('0', '' + rawData[key], '');
            }
            else {
                const item = rawData[key];
                that[key] = new media_1.Media(item.id + '', item.url, item.thumbnail_url);
            }
        });
        this.photoad_photos = Array.isArray(rawData.photoad_photos)
            ? rawData.photoad_photos.map((item) => {
                if (typeof item === 'string') {
                    return new media_1.Media('0', item, '');
                }
                return item !== null ? new media_1.Media(item.id, item.url, item.thumbnail_url) : null;
            })
            : [];
        if (this.photoad_photo !== null) {
            this.photoad_photos.push(this.photoad_photo);
        }
        if (this.photoad_photos.length === 0) {
            this.photoad_photos.push(null);
        }
        this.photoad_autoswipe_duration = rawData.photoad_autoswipe_duration || null;
        this.auto_card_timing = this.parseBool(rawData.auto_card_timing);
        this.sidebar_transparency = this.parseBool(rawData.sidebar_transparency);
        this.delay_sidebar_appearance = rawData.delay_sidebar_appearance || null;
        let userTimeZone = 'Europe/Budapest';
        try {
            userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        }
        catch (_a) { }
        let start_date_is_default = false;
        if (rawData.start_date instanceof Date) {
            this.start_date = rawData.start_date;
        }
        else if (typeof rawData.start_date === 'string') {
            this.start_date = !isNaN(Date.parse(rawData.start_date)) ? new Date(Date.parse(rawData.start_date)) : new Date();
        }
        else if (typeof rawData.start_date === 'number' && /^\d{10,13}$/.test(rawData.start_date)) {
            let theDate = parseInt(rawData.start_date, 10);
            if (theDate.toString().length === 10) {
                theDate = theDate * 1000;
            }
            this.start_date = new Date(theDate);
        }
        else {
            start_date_is_default = true;
            this.start_date = new Date();
            if (this.id == 0) {
                this.start_date.setSeconds(0);
                this.start_date.setMilliseconds(0);
                this.start_date.setTime(this.start_date.getTime() + exports.defaultTimeOffset);
            }
        }
        this.end_date = null;
        if (rawData.end_date instanceof Date) {
            this.end_date = rawData.end_date;
        }
        else if (rawData.end_date !== null && typeof rawData.end_date === 'string') {
            this.end_date = !isNaN(Date.parse(rawData.end_date)) ? new Date(Date.parse(rawData.end_date)) : null;
        }
        else if (rawData.end_date !== null && /^\d{10,13}$/.test(rawData.end_date)) {
            let theDate = parseInt(rawData.end_date, 10);
            if (theDate.toString().length === 10) {
                theDate = theDate * 1000;
            }
            this.end_date = new Date(theDate);
        }
        // @TODO - Should we manipulate data here?! Data manipulation should not be here..
        if (rawData.timezone != userTimeZone) {
            if (!start_date_is_default) {
                this.start_date = new Date(this.start_date.toLocaleString('en-US', { timeZone: rawData.timezone || undefined }));
            }
            if (this.end_date !== null) {
                this.end_date = new Date(this.end_date.toLocaleString('en-US', { timeZone: rawData.timezone || undefined }));
            }
        }
        this.feed = [];
        if (typeof rawData.feed !== 'undefined' && rawData.feed !== null) {
            const _feed = Array.isArray(rawData.feed) ? rawData.feed : Object.values(rawData.feed);
            for (const item of _feed) {
                const _item = item;
                _item.show_in_feed = typeof _item.show_in_feed === 'undefined' || _item.show_in_feed;
                this.feed.push(new feed_1.Feed(_item));
            }
        }
        if (rawData.payment !== null) {
            this.payment = new payment_1.Payment(rawData.payment);
        }
        if (this.width && this.height) {
            // Portrait fix
            if (this.orientation === 0) {
                if (this.width > this.height) {
                    const tmp = this.width;
                    this.width = this.height;
                    this.height = tmp;
                }
            }
        }
    }
    parseBool(v) {
        switch (v) {
            case true:
            case 'true':
            case 1:
            case '1':
            case 'on':
            case 'yes':
                return true;
            default:
                return false;
        }
    }
    // @TODO - Not yet finished!
    updateValues(rawData) {
        if (Object.prototype.toString.call(rawData) !== '[object Object]') {
            return;
        }
        for (const [key, value] of Object.entries(rawData)) {
            if (!this.hasOwnProperty(key)) {
                continue;
            }
            if (key === 'feed') {
                let _feeds = Array.isArray(value) ? value : Object.values(value);
                let feeds = [];
                for (const item of _feeds) {
                    feeds.push(new feed_1.Feed(item));
                }
                this[key] = feeds;
                continue;
            }
            if (key === 'polls') {
                let polls = [];
                for (const item of value) {
                    polls.push(new poll_1.Poll(item));
                }
                this[key] = polls;
                continue;
            }
            if (key === 'payment' && value) {
                this[key] = new payment_1.Payment(value);
                continue;
            }
            if (key === 'restreams' && value) {
                let platforms = [];
                for (const index in value) {
                    platforms.push(new connectedplatform_1.ConnectedPlatform(value[index]));
                }
                this[key] = platforms;
                continue;
            }
            if ((key === 'logo' || key === 'cover' || key === 'cover_portrait') &&
                Object.prototype.toString.call(value) === '[object Object]' &&
                Object.keys(value).length > 0) {
                this[key] = new media_1.Media(value.id, value.url, value.thumbnail_url);
                continue;
            }
            if (key === 'start_date' || key === 'end_date') {
                if (value) {
                    if (value instanceof Date) {
                        this[key] = new Date(value.getTime());
                    }
                    else {
                        this[key] = new Date(parseInt(value, 10) * 1000);
                    }
                    // @deprecated
                    // NOTE: This is done in _prepareEntityToSubmit() method in admin's services/Stream.js
                    //
                    // if (this[key] != null && rawData.timezone) {
                    //   const theDate = this[key] as Date;
                    //   const timezoneCorrected = moment(theDate.getTime()).tz(rawData.timezone)
                    //   this[key] = new Date(timezoneCorrected.format('MM/DD/YYYY HH:mm'))
                    // }
                }
                continue;
            }
            if (key === 'max_width' || key === 'max_height') {
                this[key] = /^\d+$/.exec(value) && parseInt(value, 10) > 0 ? parseInt(value, 10) : 0;
                if (this[key] === 0) {
                    this[key] = exports.defaultMaxDimensions[key];
                }
                continue;
            }
            this[key] = value;
        }
        this.validate();
    }
    validate() {
        if (this.type < 0) {
            throw new errors_1.StreamDataValidationError('Invalid stream type value was given. Value must be 0 or positive integer value.', 'currency');
        }
        const colors = {
            title_color: this.title_color,
            button_color: this.button_color,
            text_color: this.text_color,
        };
        for (const [fieldName, fieldValue] of Object.entries(colors)) {
            if (fieldValue != null && exports.colorRegexp.exec(fieldValue) == null) {
                throw new errors_1.StreamDataValidationError('Invalid color value was given. Supported color formats are: hex values (#000 or #000000) OR rgb() parttern.', fieldName);
            }
        }
        const currencyCodes = consts_1.streamAvailableCurrencies.map((c) => c.code);
        if (this.currency != null && !currencyCodes.includes(this.currency)) {
            throw new errors_1.StreamDataValidationError('Invalid currency was given. Available values are ' + currencyCodes.join(', ') + '.', 'currency');
        }
    }
    get products() {
        return this.feed.filter((f) => !!f.show_in_feed === true);
    }
    get streamkeyForWebcamLive() {
        return this.webcam_streamkey ? this.webcam_streamkey : this.streamkey;
    }
    get unansweredOpenPollsNumber() {
        return this.polls.filter((poll) => !poll.closed && !poll.isAnswered).length;
    }
}
exports.StreamData = StreamData;
//# sourceMappingURL=streamdata.js.map